// extracted by mini-css-extract-plugin
export default {"celebration":"celebration_celebration__AiRp4","bottom":"celebration_bottom__9lCpd"};